import React from 'react';
import PropTypes from 'prop-types';

import {currentResource} from '../../../../../../../../util/utils';
import {TAGS} from '../../utils/constants';

import Checkbox from '../../../../../../../CoreWrappers/Checkbox';
import TagLabel from '../../../../../../../Common/TagLabel';

const ColorLabelTag = ({name, id, checked, indeterminate, colorName, value, handleChange}) => {
	const handleOnChange = (id) => {
		const newValue = value.map((item) => {
			if (item.id === id) {
				return {...item, checked: !item.checked, indeterminate: false};
			}
			return {...item};
		});
		handleChange(TAGS, newValue);
	};

	const renderLabel = () => {
		let labelTag = currentResource.tags?.find((tag) => tag.id?.toLowerCase() === name?.toLowerCase().replace(/ /g, ''));
		if (labelTag === undefined) labelTag = {id, name};

		const props = {
			variant: colorName,
			text: name
		};

		return <TagLabel {...props} />;
	};

	const disabled = false;
	const props = {
		id: `checkbox-group-${id}`,
		disabled: !!disabled,
		checked: !!checked,
		indeterminate: !!indeterminate,
		value: !!checked,
		hidetitletip: true,
		className: 'checkbox',
		onChange: () => handleOnChange(id),
		label: renderLabel()
	};

	return <Checkbox {...props} />;
};

ColorLabelTag.defaultProps = {
	noOfLines: 1
};

ColorLabelTag.propTypes = {
	id: PropTypes.number.isRequired,
	styleClass: PropTypes.string.isRequired,
	key: PropTypes.string.isRequired,
	wrapperClass: PropTypes.string
};

export default ColorLabelTag;
